// This site as a TrueChops platform (src/platform/core.js; how-to at /platform): which apps it has,
// and the plugins that customize it, in JavaScript. A deployment that wants only some apps can say
// so here, or with NEXT_PUBLIC_APPS (a comma list, like "score,daw": every other app is off).
//   apps      { score, daw, map, reels, community, grow, studio, modules, practice, vault, byos, room,
//             tools, book, assistant }: false turns one off (its pages say so, the menu leaves it out)
//   plugins   client plugins, each { id, name, setup(api) } (server endpoints: truechops.server.js)
//   extensions  { marketplace, community, required }: the Extensions page on or off, people's own
//             extensions on or off, and the official extensions everyone has without adding them
//             (the Customize page, /admin/site, can change all of this without code)
// import hello from "./plugins/hello";
import school from "./plugins/school";
import lessons from "./plugins/lessons";
import { appsOff, edition } from "./src/lib/extensions/registry";

const only = (process.env.NEXT_PUBLIC_APPS || "").split(",").map((item) => item.trim()).filter(Boolean);
const ALL = ["score", "daw", "map", "reels", "community", "grow", "studio", "modules", "practice", "vault", "byos", "room", "tools", "book", "assistant", "store", "extensions", "school", "lessons", "marching"];

// An edition with a name of its own goes by it (src/lib/extensions/registry.js).
const { name, home } = edition();
const named = name ? [{ id: "edition", name, setup(api) { api.brand({ name, home }); } }] : [];

const config = {
  name: "TrueChops",
  // (The packages this edition and these flags leave out are off too: src/lib/extensions/registry.js.)
  apps: { ...(only.length ? Object.fromEntries(ALL.map((id) => [id, only.includes(id)])) : {}), ...Object.fromEntries(appsOff().map((id) => [id, false])) },
  extensions: { marketplace: true, community: true, required: [] },
  plugins: [
    // hello,
    ...named,
    school,
    lessons,
  ],
};
export default config;
